export default [
  // 学术项目
  {
    path: 'academic-project',
    name: 'AcademicProject',
    meta: {
      isDynamic: true,
      id: '会议邀约', // 11
      inTab: true
    },
    component: () =>
      import(
        /* webpackChunkName: "AcademicProject" */ '@/views/AcademicManage/AcademicProject/AcademicProject.vue'
      )
  },
  {
    path: 'edit-academic-project',
    name: 'EditAcademicProject',
    meta: {
      // isDynamic: true,
      id: '编辑学术项目' // 11
      // inTab: true
    },
    component: () =>
      import(
        /* webpackChunkName: "EditAcademicProject" */ '@/views/AcademicManage/EditAcademicProject/EditAcademicProject.vue'
      )
  }
];
